import React, { useEffect, useState } from 'react';
import { Box, InputBase, makeStyles, Typography } from '@material-ui/core';
import { DropDownIcon } from '../../../../components/Icon';
import { classNames, onKeyUpEnterOrSpace } from '../../../../utils';
import f from '../../../../comm/fontStyles';
import SelectCheckBoxPop from '../pop/SelectCheckBoxPop';
import { i18n } from '../../../../language';

const styles = makeStyles(() => ({
  root: {
    width: '10.625rem',
    height: '2.5rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderRadius: '0.5rem',
    border: 'solid 1px #e4e7eb',
    cursor: 'pointer',
  },
  typography: {
    ...f.NM_500_1rem,
    paddingLeft: '1.25rem',
    color: '#2e4469',
    '& .MuiInputBase-input': {
      cursor: 'pointer',
    },
  },
  dropDownIcon: {
    width: '1rem',
    height: '1rem',
    color: '#538fff',
    marginRight: '1rem',
    cursor: 'pointer',
  },
  inputError: {
    border: '1px solid #f44336',
  },
  errorMsg: {
    margin: '3px 0 0 0.825rem',
    color: '#f44336',
    fontFamily: 'NotoSans-Medium',
    fontWeight: '500',
  },
}));

export default function DropCheckBox({
  className,
  itemList,
  onChange,
  value,
  error,
  errorMsg,
  onBlur,
  isAllSelect,
  allSelectChange,
}) {
  const classes = styles();

  const [anchorEl, setAnchorEl] = useState(null);
  const openPop = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const closePop = () => {
    setAnchorEl(null);
    if (typeof onBlur === 'function') {
      onBlur();
    }
  };

  const [inputValue, setInputValue] = useState('');
  const onChangeHandle = (valueList) => {
    if (onChange) {
      onChange(valueList);
    }
  };

  useEffect(() => {
    if (value.length === 0) {
      setInputValue('');
    } else if (value.length === 1) {
      setInputValue(
        itemList.find((item) => {
          return value[0] === item.value;
        }).text
      );
    } else {
      setInputValue(`${value.length} ${i18n.t('NOTIFICATION_SELECTED')}`);
    }
  }, [value]);

  return (
    <>
      <Box display="flex" flexDirection="column">
        <div
          id="Notification-div-aad"
          className={
            error ? classNames(classes.root, classes.inputError, className) : classNames(classes.root, className)
          }
          onClick={openPop}
          tabIndex={0}
          onKeyUp={(e) => onKeyUpEnterOrSpace(e, openPop)}
        >
          <InputBase
            className={classes.typography}
            readOnly={true}
            placeholder={i18n.t('NOTIFICATION_SELECT_WARD')}
            value={inputValue}
          />
          <DropDownIcon className={classes.dropDownIcon} />
        </div>
        {error && <Typography className={classes.errorMsg}>{errorMsg}</Typography>}
      </Box>
      {anchorEl ? (
        <SelectCheckBoxPop
          id="Notification-SelectCheckBoxPop-aae"
          anchorEl={anchorEl}
          closePop={closePop}
          itemList={itemList}
          onChange={onChangeHandle}
          value={value}
          isAllSelect={isAllSelect}
          allSelectChange={allSelectChange}
        />
      ) : (
        ''
      )}
    </>
  );
}
